import { render, staticRenderFns } from "./ChatbotSupportAnswerChart.vue?vue&type=template&id=6db3f562"
import script from "./ChatbotSupportAnswerChart.vue?vue&type=script&lang=js"
export * from "./ChatbotSupportAnswerChart.vue?vue&type=script&lang=js"
import style0 from "./ChatbotSupportAnswerChart.vue?vue&type=style&index=0&id=6db3f562&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports